import { render, staticRenderFns } from "./yuyue.vue?vue&type=template&id=7810dd8a"
import script from "./yuyue.vue?vue&type=script&lang=js"
export * from "./yuyue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports